import React from 'react';
import ScrollHintRow from '../ScrollHintRow/ScrollHintRow';

// Popular Pixabay-style quick categories.
const CATEGORIES = [
    'nature', 'animals', 'people', 'food', 'travel',
    'business', 'technology', 'music', 'sports', 'backgrounds',
];

const CategoryChips = ({ active, onSelect, fadeClass }) => {
    return (
        // Single horizontally-scrollable row — keeps quick categories to one
        // line on every screen size, with edge fades hinting the overflow.
        // `fadeClass` lets the caller match the surface the row sits on.
        <ScrollHintRow wrapperClassName="mt-3" className="gap-2.5 py-0.5" fadeClass={fadeClass}>
            {CATEGORIES.map((cat) => {
                const isActive = active?.toLowerCase() === cat;
                return (
                    <button
                        key={cat}
                        type="button"
                        onClick={() => onSelect(isActive ? '' : cat)}
                        className={`tap-target shrink-0 inline-flex items-center capitalize text-sm font-medium px-4 py-2 rounded-full border transition-all duration-150 ${
                            isActive
                                ? 'bg-brand-500 border-brand-500 text-white shadow-e0'
                                : 'bg-white dark:bg-gray-900/50 border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:border-brand-400 hover:text-brand-600 dark:hover:text-brand-400'
                        }`}
                    >
                        {cat}
                    </button>
                );
            })}
        </ScrollHintRow>
    );
};

export default CategoryChips;
